import { render, staticRenderFns } from "./AppNavigationAddBoard.vue?vue&type=template&id=791d62ba&scoped=true&"
import script from "./AppNavigationAddBoard.vue?vue&type=script&lang=js&"
export * from "./AppNavigationAddBoard.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationAddBoard.vue?vue&type=style&index=0&id=791d62ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d62ba",
  null
  
)

export default component.exports